import io, {Socket}  from "socket.io-client";
import Cookies from "js-cookie";
import {EventMap} from "typed-emitter";
import {config} from "../../config";

const SESSION_TOKEN_COOKIE = "mercury_shared_token";

// Every socket created via io.create is registered here so a session extend
// can wake the ones the server has already dropped.
const activeSockets: Socket<any, any>[] = [];

// Reconnects only sockets that are currently disconnected. Connected sockets are
// left alone: listeners live on the socket instance, so a connect() here resumes
// them without consumers needing to re-register, and no disconnect event fires.
export function reconnectDisconnectedSockets(): void {
    activeSockets.forEach((socket) => {
        if (!socket.connected) {
            socket.connect();
        }
    });
}

// Dispatched by SessionExpired modal and useSessionManager auto-refresh after a
// new MAS token has been written to the cookie.
if (typeof globalThis.addEventListener === "function") {
    globalThis.addEventListener("mercury:session-restored", reconnectDisconnectedSockets);
}

/**
 * Default socket class placeholder
 *
 * Eventually this will include typed mappings for each service via generics
 */

export default class SocketIOSocket<S extends EventMap,C extends EventMap> {

    // public servicesUrl = "http://localhost:9090";
    public get servicesUrl() {

        const
            path = this.path.split( "/" )[1].toUpperCase().replaceAll( "-", "_" );

        console.log( path, `http://localhost:${process.env[ `REACT_APP_${path}_WS_PORT` ]}`)

        if ( process.env[ `REACT_APP_${path}_WS_PORT` ] ) {
            return `http://localhost:${process.env[ `REACT_APP_${path}_WS_PORT` ]}`
        }

        return config.SERVICES_API_URL;
    }

    public socket:Socket<C,S>;

    private token:string;
    private path:string;

    constructor( path: string, token:string, ns:string ) {

        this.token = token;
        this.path = path;
        this.socket = io( `${this.servicesUrl}/${ns}`,
        {
            path,
            // Evaluated on every (re)connection attempt, so reconnects after a
            // session extend authenticate with the refreshed cookie token
            // instead of the one captured at construction.
            auth: ( cb ) => cb( { token: Cookies.get( SESSION_TOKEN_COOKIE ) || this.token } ),
            transports: ['websocket']
        })

        activeSockets.push( this.socket );

        this.socket.on("connect_error", (err) => {
            console.error( err , ns);
        });

        this.socket.on( "connect", () => {
            console.log( "Connected" );
        })


        // Todo: socket monitoring
        // this.socket.onAnyOutgoing(() => {
        //     console.log( "out" )
        // });
        //
        // this.socket.onAny(() => {
        //     console.log( "in" )
        // });
    }

    static create( path:string, token:string, ns:string ) {
        return new SocketIOSocket( path, token, ns ).socket;
    }
}

export { SocketIOSocket, Socket };
